import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class NewslettersService {

  constructor(private http: HttpClient) { }

  getAllNewsLetters(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/newsLetter?size=100`, {'headers': headers});
  }

  //api/newsLetter/sendInfo
  sendNewsletterInfos(newsLetterInfo: any): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.post<any>(`${environment.url}/newsLetter/sendInfo`,newsLetterInfo, {'headers': headers});
  }

}
